<template>
  <div class="main_area">
    <div class="type_menu_area">
      <div class="type_menu wallet_menu menu_area_bg">
        <div class="type_menu_item">
          <a @click="$parent.goNav('/wallet')"><span>存款</span></a>
        </div>
        <div class="type_menu_item active">
          <a href=""><span>取款</span></a>
        </div>
        <div class="type_menu_item">
          <a @click="$parent.goNav('/transfer')"><span>转账</span></a>
        </div>
      </div>
    </div>
    <div class="detail_area">
      <div class="deposit-container wallet-container">
        <div class="layout">
          <div class="deposit_container layout wallet_withdrawl_layout">
            <div class="deposit_header tableheader_bg">
              <div>主钱包余额</div>
              <div class="d-flex align-items-center">
                <span class="wallet_balance mr-2 main_wallet_bal">{{ $store.state.userInfo.balance }}</span> <img alt="" @click="$parent.getUserInfos" src="/static/image/refresh_reverse.png" id="reload_wallet" />
              </div>
            </div>
            <div class="deposit_header">
              <div>打码量</div>
              <div class="d-flex align-items-center">
                <span class="wallet_balance mr-2 main_wallet_bal" style="color: #fff">{{ betAmount }}</span>
              </div>
            </div>
            <div class="deposit_body transfer_deposit_body default">
              <div class="withdrawal_scrollable_container">
                <div class="withdrawal_onekey_receive">
                  <div class="deposit_hints">温馨提示：尚有余额之游戏平台，可能因平台政策因素，无法将余额全数返还至主钱包中。</div>
                </div>
                <!-- <label class="textbox_content">
								<input type="text" disabled="" placeholder="其他游戏平台钱包无余额">
							</label> -->
              </div>
            </div>
          </div>
          <div class="withdrawal_form_container">
            <div class="withdrawal_scrollable_form">
              <div id="withdrawal_form">
                <div class="deposit_hints txt">温馨提示：取款金额需大于取款费用方能取款。</div>
                <div>
                  <div class="withdrawal_details">
                    <label class="textbox_content">
                      <select v-model="qutype" @change="satusSelect">
                        <option :value="0">取款到银行卡</option>
                        <option :value="1">取款到虚拟钱包</option>
                      </select>
                    </label>
                  </div>
                </div>
                <div v-if="qutype == 0">
                  <div class="withdrawal_details">
                    <label class="textbox_content">
                      <select v-model="bankId">
                        <option :value="null" disabled selected>请选择银行卡</option>
                        <option :value="item.id" v-for="(item, index) in usercardLis" :key="index">{{ item.bank }} ---{{ item.bank_no }}</option>
                      </select>
                    </label>
                  </div>
                </div>
                <div v-if="qutype == 1">
                  <div class="withdrawal_details">
                    <label class="textbox_content">
                      <select v-model="bankId" @change="changApiType">
                        <option :value="null" disabled selected>请选择钱包地址</option>
                        <option :value="item.id" v-for="(item, index) in usdssLis" :key="index">{{ item.bank_owner }}---{{ item.bank_no }}</option>
                      </select>
                    </label>
                  </div>
                </div>
                <div>
                  <div class="withdrawal_details">
                    <label class="textbox_content">
                      <input type="text" v-model="amount" placeholder="请输入取款金额" id="amount" name="amount" class="finance_amount" />
                    </label>
                  </div>
                </div>
                <div>
                  <div class="withdrawal_details">
                    <label class="textbox_content">
                      <input type="password" v-model="password" autocomplete="new-password" placeholder="支付密码" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" class="finance_amount" />
                    </label>
                  </div>
                </div>
                <div v-if="qutype == 1">
                  <div style="color: #adadad; margin-top: 6px" v-if="chanmeyXi">每笔手续费：{{ chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee : $store.state.userInfo.withdrawfeeusdttrc }}USDT</div>
                  <div style="color: #adadad; margin-top: 6px">USDT换算：{{ amount ? Math.floor((amount / $store.state.userInfo.withdrawusdtrate) * 100) / 100 : '0.00' }}USDT &nbsp;&nbsp;&nbsp;&nbsp;参考汇率：{{ $store.state.userInfo.withdrawusdtrate }}</div>
                  <div style="color: #adadad; margin-top: 6px">实际到账：{{ amount ? Math.floor((amount / $store.state.userInfo.withdrawusdtrate) * 100) / 100 - (chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee * 1 : $store.state.userInfo.withdrawfeeusdttrc * 1) : '0.00' }}USDT</div>
                </div>
                <div data-v-7c9a7985="" class="textbox_content" style="padding-bottom: 20px; margin-top: 6px">
                  <button v-if="qutype == 0" data-v-7c9a7985="" id="payment" class="btn w-100 btn_action active" @click="withdraw">确定充值</button>
                  <button v-if="qutype == 1" data-v-7c9a7985="" id="payment" class="btn w-100 btn_action active" @click="withdraw1">确定充值</button>
                </div>

                <div id="withdrawal_without_card_password">
                  <div class="withdrawal_decscription_title">
                    <div class="txt_title">快捷管理</div>
                    <div class="notice_alert"><b></b></div>
                  </div>
                  <div class="withdrawal">
                    <div>
                      <a @click="$parent.goNav('/addBankCard')" v-if="usercardLis.length < 5">
                        <div class="pshortcut">
                          <div class="icon_circle_card"><img alt="" src="/static/image/bankcards_bg.png" /></div>
                          <div>
                            <div class="txt_label">添加银行卡</div>
                          </div>
                        </div>
                      </a>
                      <a @click="$parent.goNav('/addUsdtAds')" class="set_withdrawal_pin" v-if="usdssLis.length < 5">
                        <div class="pshortcut">
                          <div class="icon_circle_card"><img alt="" src="/static/image/record_bg.png" /></div>
                          <div>
                            <div class="txt_label">添加电子钱包</div>
                          </div>
                        </div>
                      </a>
                      <a @click="$parent.goNav('/mine?show=1')" class="set_withdrawal_pin">
                        <div class="pshortcut">
                          <div class="icon_circle_card reddot"><img alt="" src="/static/image/popup_pin.png" /></div>
                          <div>
                            <div class="txt_label">修改支付密码</div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'withdraw',
  data() {
    return { qutype: 0, bankId: null, password: null, amount: null, usdssLis: [], usercardLis: [], chanmeyXi: null, betAmount: null };
  },
  created() {
    let that = this;
    that.getBetAmount();

    that.getUsercard();
    that.getUsdssList();
  },
  methods: {
    getBetAmount() {
      let that = this;
      that.$apiFun
        .post('/api/getBetAmount', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.betAmount = res.data.bet_amount;
          }
        })
        .catch(res => {});
    },
    changApiType(e) {
      let that = this;
      if (that.qutype == 1) {
        let chanmeyXi = null;
        that.usdssLis.forEach(el => {
          if (el.id == that.bankId) {
            chanmeyXi = el.bank_owner;
            return;
          }
        });
        that.chanmeyXi = chanmeyXi;
      } else {
        that.chanmeyXi = null;
      }

      that.password = null;
      that.amount = null;
    },
    withdraw() {
      let that = this;
      // amount	是	float	金额
      // bank	是	int	提现银行卡id
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;

      if (amount < 100) {
        that.$parent.showTost(0, '单笔取款不能低于100元');
        return;
      }
      if (!bank) {
        that.$parent.showTost(0, '请选择您要提现到的银行卡');
        return;
      }
      if (!password) {
        that.$parent.showTost(0, '请输入您的支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '提交成功，等待后台审核');

            that.amount = null;
            that.password = null;
            that.bank = null;
            setTimeout(() => {
              that.$router.push({ path: '/fundingRecords' });
            }, 1500);
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    withdraw1() {
      //  amount: "100"
      // bank: 163
      // bank_owner: "TRC20"
      // password: "1"
      let that = this;
      // amount	是	float	金额
      // bank	是	int	提现银行卡id
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;
      if (!bank) {
        that.$parent.showTost(0, '请选择USDT地址');
        return;
      }
      if (amount < 100) {
        that.$parent.showTost(0, '单笔取款不能低于100元');
        return;
      }

      if (!password) {
        that.$parent.showTost(0, '请输入您的支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.showTost(1, '提交成功，等待后台审核');
            that.chanmeyXi = null;
            that.amount = null;
            that.password = null;
            that.bank = null;
            setTimeout(() => {
              that.$router.push({ path: '/fundingRecords' });
            }, 1500);
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    satusSelect(event) {
      this.bankId = null;
      this.password = null;
      this.amount = null;
    },
    getUsercard() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.usercardLis = res.data;
        }
      });
    },
    getUsdssList() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.usdssLis = res.data;
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mode/withdraw.vue